import { CSSProperties } from 'react'

const styles: {
  overlay: CSSProperties
  card: CSSProperties
  buttonRow: CSSProperties
} = {
  overlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    width: 300,
    height: 300,
    backgroundColor: 'gold',
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'column',
  },
  buttonRow: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'flex-end',
    justifyContent: 'space-around',
    width: '100%',
  },
}

export default styles
